import * as React from 'react'
import TrialLessonContentPc from '../../public/trial_lesson_content_pc.png'
import TrialLessonContentSp from '../../public/trial_lesson_content_sp.png'

type Props = { isPc: boolean }

export const TrialLessonContentForAB = ({ isPc }: Props) => {
  return (
    <section className="bg-orange-50 p-0 lg:pt-10">
      <div className="flex justify-center items-center max-w-full">
        <img
          src={isPc ? TrialLessonContentPc.src : TrialLessonContentSp.src}
          alt="Trial Lesson Content"
          className="w-[90%] md:w-[70%] lg:w-[35%] max-w-full h-auto block"
        />
      </div>
    </section>
  )
}
